<template>
  <v-card
    elevation="0"
    tile
    outlined
    class="pa-4 mt-2 mb-2 d-flex flex-row justify-space-between"
  >
    <img
      v-if="data.images && data.images.length > 0"
      class="flex-shrink-1"
      :src="data.images[0].path"
      :alt="data.images[0].nombre"
      width="200px"
    />

    <div class="flex-grow-1 ml-2">
      <div class="text-h6">{{ data.nombre }}</div>
      <div>{{ data.descripcion }}</div>
      <div class="subtitle-1 mr-2">$ {{ data.precio }} C/U</div>
    </div>
    <v-divider class="flex-shrink-1" vertical></v-divider>
    <div class="flex-shrink-1 d-flex flex-column justify-space-between">
      <div class="flex-shrink-1 subtitle-1 mr-2 ml-2">
        Total: $ {{ data.precio }}
      </div>
      <div class="inputCantidad">
        <div>
          <v-btn small text @click="minusIconCallback">
            <v-icon>mdi-minus</v-icon>
          </v-btn>
          <span>{{ cantidad }}</span>
          <v-btn small text @click="plusIconCallback">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>
      </div>
      <v-btn color="error" class="caption" small text @click="addProducto">
        ELIMINAR
      </v-btn>
    </div>
  </v-card>
</template>

<script>
// import CarouselImages from './CarouselImages.vue'

export default {
  // components: { CarouselImages },
  props: {
    data: Object,
    index: Number,
    isProductDeletionPending: Boolean,
    disableActions: Boolean
  },
  data() {
    return {
      cantidad: 1
    }
  },
  computed: {
    categoriaText() {
      return this.data.categoria
    }
  },
  methods: {
    addProducto() {
      console.log(
        '🚀 ~ file: ProductoCatalogo.vue ~ line 76 ~ addProducto ~ addProducto'
      )
    },
    plusIconCallback() {
      if (this.cantidad < 15) this.cantidad += 1
    },
    minusIconCallback() {
      if (this.cantidad > 1) this.cantidad -= 1
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';

.product-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .product-link {
    color: $vue-color;
  }

  .delete-btn {
    cursor: pointer;
    padding: 5px 10px;
    border: 1px solid;
    display: inline-block;
    border-radius: 3px;
    margin-left: 10px;
    color: $danger-color;
    border-color: $danger-color;
  }
}

.card {
  /* Add shadows to create the "card" effect */
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 5px; /* 5px rounded corners */
}

/* On mouse-over, add a deeper shadow */
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

/* Add some padding inside the card container */
.container {
  padding: 2px 16px;
}

img {
  border-radius: 5px 5px 0 0;
}
</style>
